import React from 'react';
import PropTypes from 'prop-types';

// Components

import { Modal } from '@beef/ui-kit';
import { RequestStatus } from '@beef/smart-kit';

import { roamingParamShape } from '../../../propTypes';

const PackagePopup = ({ isOpen, param, onClose }) => (
  <Modal
    isOpen={isOpen}
    isCentered
    onClose={onClose}
  >
    <RequestStatus
      title={param?.title}
      description={param?.description}
      button={{ text: param?.btnText, variant: 'main' }}
      onConfirm={onClose}
    />
  </Modal>
);

PackagePopup.propTypes = {
  isOpen: PropTypes.bool,
  param: roamingParamShape,
  onClose: PropTypes.func,
};

export { PackagePopup };
